<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Email</span>
  <input id="Email" [(ngModel)]="cliente.email" type="text" class="form-control"
    aria-label="Email" aria-describedby="inputGroup-sizing-default" disabled>
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Contraseña</span>
  <input id="password" [(ngModel)]="cliente.password" type="password" class="form-control"
    aria-label="password" aria-describedby="inputGroup-sizing-default">
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">DNI</span>
  <input id="dni" [(ngModel)]="cliente.dni" type="number" class="form-control"
    aria-label="dni" aria-describedby="inputGroup-sizing-default" disabled>
</div>
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Nombre y Apellido</span>
  <input id="nombreApellido" [(ngModel)]="cliente.nombres" type="text" class="form-control"
    aria-label="nombreApellido" aria-describedby="inputGroup-sizing-default" disabled>
</div>
<button class="btn btn-success" (click)="newDir(0)">Nuevo</button>
<table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark">
  <thead class="table-dark">
    <tr>
      <th scope="col">Alias</th>
      <th scope="col">Direccion</th>
      <th scope="col">Telefono</th>

    </tr>
  </thead>
<tbody class="table-light">
  <tr *ngFor="let m of direcciones">
    <th >{{m.nombre}}</th>
    <th >{{m.provincia}}, {{m.localidad}}, {{m.direccion}} ({{m.cp}}) {{m.piso_dpto}}</th>
    <th >{{m.telefono}}</th>
  </tr>

</tbody>
</table>

<!-- <div><button class="btn btn-primary" type="button" (click)="cargar()">Guardar</button></div> -->
